import { StrictMode, useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { LoginPage } from "./pages/LoginPage";
import { HomePage } from "./pages/HomePage";
import { SalesPage } from "./pages/SalesPage";
import { CSMPage } from "./pages/CSMPage";
import { Toaster } from "sonner";
import "./styles/globals.css";

export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    checkAuth();

    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const checkAuth = async () => {
    try {
      const response = await fetch("/api/auth/check");
      const data = await response.json();
      setIsAuthenticated(data.authenticated);

      if (!data.authenticated && currentPath !== "/login") {
        navigate("/login");
      }
    } catch (err) {
      setIsAuthenticated(false);
      navigate("/login");
    }
  };

  const navigate = (path: string) => {
    window.history.pushState({}, "", path);
    setCurrentPath(path);
  };

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    navigate("/");
  };

  if (isAuthenticated === null) {
    return (
      <>
        <Toaster position="top-right" />
        <div className="container mx-auto p-8 flex items-center justify-center min-h-screen">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <Toaster position="top-right" />
        <LoginPage onLoginSuccess={handleLoginSuccess} />
      </>
    );
  }

  let content;
  switch (currentPath) {
    case "/sales":
      content = <SalesPage onNavigate={navigate} />;
      break;
    case "/csm":
      content = <CSMPage onNavigate={navigate} />;
      break;
    default:
      content = <HomePage onNavigate={navigate} />;
  }

  return (
    <>
      <Toaster position="top-right" />
      {content}
    </>
  );
}

export default App;

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}
